(() => {
  'use strict';
  if (customElements.get('salem-ratings-carousel')) return;
  customElements.define('salem-ratings-carousel', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const {signal} = this.controller;
      this.track = this.querySelector('[data-ratings-track]');
      this.panel = this.querySelector('[data-ratings-panel]');
      this.native = this.querySelector('details');
      this.previous = this.querySelector('[data-ratings-prev]');
      this.next = this.querySelector('[data-ratings-next]');
      this.status = this.querySelector('[data-ratings-status]');
      this.signature = '';
      this.update = () => {
        const widget = this.querySelector('.jdgm-review-widget');
        if (!widget) return;
        let data = window.jdgm?.data?.reviewWidget?.[widget.dataset.productId];
        if (!data) {
          const source = this.querySelector('.jdgm-review-widget-data')?.textContent;
          const match = source?.match(/reviewWidget\[[^\]]+\]\s*=\s*(\{[\s\S]*\})\s*;?\s*$/);
          if (match) { try { data = JSON.parse(match[1]); } catch { return; } }
        }
        if (!data?.reviews?.length) return;
        const signature = JSON.stringify(data);
        if (signature === this.signature) return;
        this.signature = signature;
        const fragment = document.createDocumentFragment();
        const element = (tag, className, text) => {
          const node = document.createElement(tag);
          node.className = className;
          if (text != null) node.textContent = text;
          return node;
        };
        data.reviews.forEach(review => {
          const card = element('article', 'sr-card');
          const stars = element('div', 'sr-card-stars', '★★★★★');
          stars.setAttribute('role', 'img');
          stars.setAttribute('aria-label', `${review.rating} de 5 estrelas`);
          stars.textContent = '★'.repeat(Math.max(0, Math.min(5, Number(review.rating) || 0))) + '☆'.repeat(5 - Math.max(0, Math.min(5, Number(review.rating) || 0)));
          card.append(stars);
          if (review.title) card.append(element('h3', 'sr-card-title', review.title));
          card.append(element('blockquote', 'sr-card-quote', review.body));
          const profile = element('div', 'sr-card-profile');
          const avatar = element('span', 'sr-card-avatar', review.reviewer_initial || (review.reviewer_name || 'A').slice(0, 1));
          avatar.setAttribute('aria-hidden', 'true');
          const info = element('div', 'sr-card-info');
          info.append(element('strong', '', review.reviewer_name || 'Anônimo'));
          const date = new Date(review.created_at);
          if (!Number.isNaN(date.getTime())) {
            const time = element('time', '', new Intl.DateTimeFormat('pt-BR', {day:'2-digit', month:'long', year:'numeric'}).format(date));
            time.dateTime = review.created_at;
            info.append(time);
          }
          profile.append(avatar, info);
          card.append(profile);
          if (review.verified_buyer) card.append(element('p', 'sr-card-source', 'Compra verificada pelo Judge.me'));
          else if (review.transparency_badges?.includes('review_collected_from_store_visitor')) card.append(element('p', 'sr-card-source', 'Avaliação enviada por visitante da loja'));
          fragment.append(card);
        });
        this.track.replaceChildren(fragment);
        this.track.scrollLeft = 0;
        const average = Number(data.average_rating);
        this.querySelector('[data-ratings-average]').textContent = Number.isFinite(average) ? average.toLocaleString('pt-BR', {minimumFractionDigits:1, maximumFractionDigits:1}) + ' / 5' : '';
        this.querySelector('[data-ratings-count]').textContent = `${data.number_of_reviews} ${Number(data.number_of_reviews) === 1 ? 'avaliação' : 'avaliações'} no Judge.me`;
        this.panel.hidden = false;
        if (!this.hasAttribute('data-ready')) this.native.open = false;
        this.setAttribute('data-ready', '');
        this.sync();
      };
      this.sync = () => {
        const cards = [...this.track.children];
        if (!cards.length) return;
        const index = cards.reduce((best, card, i) => Math.abs(card.offsetLeft - this.track.offsetLeft - this.track.scrollLeft) < Math.abs(cards[best].offsetLeft - this.track.offsetLeft - this.track.scrollLeft) ? i : best, 0);
        const overflow = this.track.scrollWidth > this.track.clientWidth + 2;
        this.previous.disabled = !overflow || this.track.scrollLeft <= 2;
        this.next.disabled = !overflow || this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
        this.querySelector('[data-ratings-controls]').hidden = !overflow;
        this.status.textContent = `${index + 1} / ${cards.length}`;
      };
      const move = direction => {
        const card = this.track.firstElementChild;
        if (!card) return;
        this.track.scrollBy({left:direction * (card.getBoundingClientRect().width + 20), behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      this.previous.addEventListener('click', () => move(-1), {signal});
      this.next.addEventListener('click', () => move(1), {signal});
      this.track.addEventListener('scroll', this.sync, {signal, passive:true});
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1);
      }, {signal});
      this.observer = new MutationObserver(this.update);
      this.observer.observe(this.querySelector('.sr-widget'), {subtree:true, childList:true, characterData:true});
      this.resize = new ResizeObserver(this.sync); this.resize.observe(this.track);
      this.update();
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); this.resize?.disconnect(); }
  });
})();
